export default [
  {
    path: '/modules/financial/contabil/dre',
    name: 'contabilDre',
    component: () => import('@/views/modules/financial/contabil/DreReport.vue'),
    meta: {
      action: 'ROLE_FINAN_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'DRE',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Contábil' },
        { text: 'DRE', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/contabil/livro-razao',
    name: 'contabilLivroRazao',
    component: () => import('@/views/modules/financial/contabil/LivroRazaoReport.vue'),
    meta: {
      action: 'ROLE_FINAN_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Livro Razão',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Contábil' },
        { text: 'Livro Razão', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/contabil/razao-analitico',
    name: 'contabilRazaoAnalitico',
    component: () => import('@/views/modules/financial/contabil/RazaoAnaliticoReport.vue'),
    meta: {
      action: 'ROLE_FINAN_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Razão Analítico',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Contábil' },
        { text: 'Razão Analítico', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/contabil/razao-hierarquico',
    name: 'contabilRazaoHierarquico',
    component: () => import('@/views/modules/financial/contabil/RazaoHierarquicoReport.vue'),
    meta: {
      action: 'ROLE_FINAN_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Razão Hierárquico',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Contábil' },
        { text: 'Razão Hierárquico', active: true },
      ],
    },
  },
]
